/**
 * Creates a deep mutable clone of the provided object.
 *
 * This function uses JSON serialization and deserialization to produce a deep copy of
 * the input object. The clone is mutable regardless of the original object's mutability.
 * Note that this method does not preserve functions, undefined properties, or special types
 * such as Date, Map, or Set.
 *
 * @template T - The type of the object to clone.
 * @param {T} obj - The object to be cloned.
 * @returns {T} A deep mutable clone of the provided object.
 */
export const createDeepMutableClone = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj)) as T;
};
